module.exports = __webpack_public_path__ + "56e469d6b8a818d132b1051f055fa99d.png";